import React from "react";
//#region types
import { TranslationKeys } from "translations";
import { ReportConstants } from "utils/constants";
//#endregion
//#region components
import { DashboardButtonGroup, PageLayouts, ReloadEvent } from "components/common";
import { Grid } from "@mui/material";
import CreateSharedDocumentButton from "./createSharedDocumentButton";
import SharedDocumentsList from "./list";
import useSharedDocumentPermissions from "./hooks/useSharedDocumentPermissions";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";

const SharedDocumentReport: React.FC = (props) => {
  const { hasSharedDocumentViewPermissions, hasSharedDocumentCreatePermissions } = useSharedDocumentPermissions();

  return (
    <ReloadEvent
      uniqueKey={ReportConstants.ReportKeys.SharedDocuments}
      render={(reloadKey, reload) => (
        <PageLayouts.DashboardLayout
          entityKey={0}
          hasPermissions={hasSharedDocumentViewPermissions()}
          title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Document.SharedDocuments)}
          topRightButtons={
            hasSharedDocumentCreatePermissions() ? (
              <DashboardButtonGroup buttons={[<CreateSharedDocumentButton onCreateSuccess={reload} />]} />
            ) : undefined
          }
        >
          <Grid container item>
            <SharedDocumentsList reloadKey={reloadKey} />
          </Grid>
        </PageLayouts.DashboardLayout>
      )}
    />
  );
};

export default SharedDocumentReport;
